const INTERNAL_EMAILS = new Set([
  'paulruske@iinet.net.au',
  'eltonsupport@mac.com',
  'sales@sitescopeapp.com',
  'support@sitescopeapp.com',
]);

export function canUseInternalAdmin(email) {
  return INTERNAL_EMAILS.has(String(email || '').trim().toLowerCase());
}
